import React from "react";
import { motion } from "framer-motion";

const EXEJoinCall = () => {
  // return (
  //   <section className="exe-section">
  //     <div className="exe-container">
  //       <motion.div
  //         initial={{ opacity: 0, y: 30 }}
  //         whileInView={{ opacity: 1, y: 0 }}
  //         transition={{ duration: 0.4 }}
  //         viewport={{ once: true }}
  //         className="exe-glass-card p-12 text-center"
  //       >
  //         <h2 className="exe-title text-exe-text-accent mb-6">
  //           Registrations Closed {/* {Ready to Compete?} */}
  //         </h2>
  //         <p className="exe-text text-xl mb-8 max-w-3xl mx-auto">
  //           Join hundreds of developers in Sri Lanka's premier game development competition. 
  //           Whether you're a student, professional, or hobbyist - EXE is your stage to shine.
  //         </p>
  //         
  //         <div className="flex flex-col sm:flex-row gap-6 justify-center">
  //           <motion.a
  //             href="/register"
  //             className="exe-btn exe-btn-primary text-lg px-8 py-4"
  //             whileHover={{ scale: 1.05, boxShadow: "0 0 30px rgba(0, 255, 65, 0.6)" }}
  //             whileTap={{ scale: 0.95 }}
  //           >
  //             Register Now
  //           </motion.a>
  //           
  //           <motion.a
  //             href="/rules"
  //             className="exe-btn exe-btn-outline text-lg px-8 py-4"
  //             whileHover={{ scale: 1.05 }}
  //             whileTap={{ scale: 0.95 }}
  //           >
  //             Learn More
  //           </motion.a>
  //         </div>
  //       </motion.div>
  //     </div>
  //   </section>
  // );

  return (
    <section className="exe-section">
      <div className="exe-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          viewport={{ once: true }}
          className="exe-glass-card p-12 text-center"
        >
          <h2 className="exe-title text-exe-text-accent mb-6">
            Stay Tuned for EXE 2026!
          </h2>
          <p className="exe-text text-xl mb-8 max-w-3xl mx-auto">
            The competition is now over. Thank you for your amazing participation!<br />
            Get ready for EXE 2026 - an even bigger and better game development experience is coming your way.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default EXEJoinCall;
